'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/layout/style/css.js
// module id = 965
// module chunks = 0